<template>
  <div class="answer__content">
    <div style="width: 60%">
      <div class="card">
        <div class="card_body">
          <div class="card_tab">
            <i></i>练习题目
            <!-- <el-statistic
              ref="uCountDown"
              @finish="countDownEnd"
              format="HH:mm:ss"
              :value="Date.now() + 1000 * timestamp"
              title="倒计时："
              time-indices
              style="display: flex;width: 23%;position: absolute; right: 10%;justify-content: center;align-items: center;"
            >
            </el-statistic> -->
            <div class="exam-number" style="position: absolute; right: 0">{{ showQuestionIndex + 1 }}/{{ newOptList.length }}</div>
          </div>

          <!-- banner -->
          <div v-if="newOptList[showQuestionIndex] && newOptList[showQuestionIndex].pic && newOptList[showQuestionIndex].pic !== ''">
            <div :class="['answer__banner', switchVisible ? 'question--find-out' : 'question--find-in']">
              <img :src="newOptList[showQuestionIndex].pic" mode="aspectFill" />
            </div>
          </div>
          <div :class="['answer__question', switchVisible ? 'question--find-out' : 'question--find-in']" v-if="newOptList.length" style="margin-top: 11px">
            <!-- 题目类型 -->
            <div class="title-tips">
              {{ getQuestionType(newOptList[showQuestionIndex].type) }}
            </div>
            <!-- 题目 -->
            <div class="question_title">
              <!-- <div class="title__number">{{ newOptList[showQuestionIndex].number || showQuestionIndex + 1 }}.</div> -->
              <div>
                {{ newOptList[showQuestionIndex].topic }}
              </div>
            </div>
            <!-- 答案选项 -->
            <div class="question__option">
              <div v-if="selectKey.includes(newOptList[showQuestionIndex].type)">
                <div v-for="(item, index) in newOptList[showQuestionIndex].question_option" :key="index">
                  <div
                    :style="item.active ? optActiveStyle : optStyle"
                    class="question__option__item"
                    @click.stop="checkOption"
                    :data-id="item.id"
                    :class="[newOptList[showQuestionIndex].answer.filter((it) => it == item.id).length > 0 ? '' : item.active && openTipCards ? 'falseBc' : '']"
                  >
                    <div class="question__option__item__number">{{ item.topic }} .</div>
                    <div style="margin-right: 11px">{{ item.content }}</div>
                    <!-- 解析-点击情况判断对错 -->
                    <div
                      v-if="openTipCards && item.active"
                      :class="[newOptList[showQuestionIndex].answer.filter((it) => it == item.id).length > 0 ? 'rightIcon' : 'falseIcon']"
                    ></div>
                    <!-- 解析-未点击情况标注答案 -->
                    <div
                      v-if="openTipCards"
                      :class="[newOptList[showQuestionIndex].answer.filter((it) => it == item.id).length > 0 ? (item.active ? '' : 'rightIcon') : '']"
                    ></div>
                  </div>
                </div>
              </div>
              <div v-else-if="newOptList[showQuestionIndex].type == 'write'">
                <div class="item__key__box">
                  答案：
                  <input class="write_input" placeholder="请填写你的答案" v-model="newOptList[showQuestionIndex].question_key" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 解题思路 -->
      <div
        class="card"
        v-if="newOptList[showQuestionIndex]"
        :class="newOptList[showQuestionIndex].openTipCard == true ? 'open_card' : 'close_card'"
        padding="20"
        :border="false"
        :foot-border-top="false"
        :head-border-bottom="false"
        :full="true"
        margin="0 11px 18px"
        :show-head="false"
      >
        <div class="card_body">
          <div style="padding: 3px"></div>
          <div class="analysis-title" @click="changeTipStatus()" :style="{ marginBottom: newOptList[showQuestionIndex].openTipCard ? '25px' : '0px' }">
            <div style="display: flex; align-items: center">
              <text class="line"></text>
              试题详解
              <text class="line"></text>
            </div>
            <i
              :class="newOptList[showQuestionIndex].openTipCard == true ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              style="font-size: 15px; position: absolute; right: 0"
            ></i>
          </div>
          <div class="analysis-top" v-if="newOptList[showQuestionIndex].openTipCard">
            <div class="left">
              正确答案 <span style="color: rgb(255, 175, 15); text-indent: 2em">&nbsp;&nbsp;{{ trueA }} </span>
            </div>
          </div>
          <div class="analysis-content" v-if="newOptList[showQuestionIndex].openTipCard">
            <div class="title">题目解析</div>
            <div class="content-a">
              {{ newOptList[showQuestionIndex].answer_key == "" ? "暂无解析内容" : newOptList[showQuestionIndex].answer_key }}
            </div>
          </div>
          <div style="padding: 7px"></div>
        </div>
      </div>
      <div class="answer__next__btn" v-if="newOptList.length && newOptList[showQuestionIndex].topic">
        <div class="bottom-left">
          <div class="star" @click="startItem(newOptList[showQuestionIndex].id)">
            <!-- <image src="/static/img/star.png" mode="aspectFill"></image> -->
            <i class="el-icon-star-off" v-show="newOptList[showQuestionIndex].is_collect == false" style="font-size: 18px"></i>
            <i class="el-icon-star-on" v-show="newOptList[showQuestionIndex].is_collect == true" color="#f3b240" style="font-size: 22px"></i>
            收藏
          </div>
          <div class="right">
            <div class="img">
              <img src="@/assets/icon/answer-true.png" mode="aspectFill" />
            </div>
            {{ statistics.yes ? statistics.yes : 0 }}
          </div>
          <div class="fault">
            <div class="img">
              <img src="@/assets/icon/answer-false.png" mode="aspectFill" />
            </div>
            {{ statistics.no ? statistics.no : 0 }}
          </div>
        </div>
        <div class="btns">
          <div class="answer_pro" v-show="isStart" :style="nextStyle" @click.stop="proQuestionBtn">
            {{ "上 一 题" }}
          </div>
          <div class="answer_pro pro-right" :style="nextStyle" @click.stop="nextQuestionBtn" v-if="openTipCards == false">
            {{ isEnd ? "提交 " : "下 一 题" }}
          </div>
          <div class="answer_pro pro-right" :style="nextStyle" @click.stop="nextQuestionBtn" v-if="openTipCards == true && isEnd == false">
            {{ isEnd ? "提交 " : "下 一 题" }}
          </div>
        </div>
      </div>
    </div>
    <!-- 答题卡 -->
    <div class="card" style="width: 36%">
      <div class="card_body">
        <div class="card_tab"><i></i>答题卡</div>
        <div class="content">
          <div style="min-height: 342px">
            <div class="choice-list">
              <div
                class="list-item"
                v-for="(item, index) in newOptList.length"
                :key="index"
                :class="tikaList[index] ? (tikaList[index] == 'yes' ? 'item-r' : tikaList[index] == 'no' ? 'item-f' : '') : ''"
                @click="toThis(index)"
              >
                {{ index + 1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="answer__next__btn" :style="nextStyle" @click.stop="nextQuestionBtn">
			{{ isEnd ? '提  交' : '下 一 题' }}
		</div> -->

    <!-- 提交提示 -->
    <el-dialog title="温馨提示" :visible.sync="confirmSubmission" width="30%">
      <div style="padding: 25px; display: flex; justify-content: center; align-items: center; flex-direction: column; font-size: 16px">
        <span>{{ content }}</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmSubmission = false">取 消</el-button>
        <el-button type="primary" @click="confirmSub()">立即提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    questionList: {
      //数据列表
      type: Array,
      default: () => [],
    },
    colorStyle: {
      type: Object,
      default: () => {},
    },
    warningTips: {
      type: String,
      default: "请先作答哦~",
    },
    trueTips: {
      //是否已提交，显示正确答案提示
      type: Boolean,
      default: false,
    },
    pushStatus: {
      //提交答案是否有错误，0为无错误，1为有错误
      type: Number,
      default: 0,
    },
    openTipCards: {
      type: Boolean,
      default: false,
    },
    timestamp: {
      type: Number,
      default: 3600,
    },
    tikaList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      openTipCard: false,
      showAnswerNumber: false,
      colorMap: {
        nextBac: "#eb564c",
        nextCol: "#FFFFFF",
        optBac: "#f3f4f5",
        optCol: "#102032",
        optBacActive: "#fbe5e3",
        optColActive: "#eb564c",
      },
      selectKey: ["radio", "checkbox", "determine"],
      newOptList: [], //初始化数据
      showQuestionIndex: 0, //当前展示题号
      isEnd: false, //是否为最后一题
      isStart: false, //是否第一题
      switchVisible: false, // 切换状态
      pro: false, //上一题
      next: true, //下一题
      confirmSubmission: false,
      confirmStyle: {
        backgroundColor: "#eb564c",
        color: "#ffffff",
        // width: '274px',
        // height: '53px'
      },
      content: "确定提交吗？",
      lastOpt: {},
      chooseAnswer: "", //选择答案
      trueA: "", //正确答案
      answerList: [], //答案列表
      chooseList: [], //选择列表
      // tikaList: [],
      statistics: {},
      allTime: 0,
      timeStart: null,
    };
  },
  watch: {},
  computed: {
    nextStyle() {
      return `background:${this.colorMap.nextBac};color:${this.colorMap.nextCol};`;
    },
    optStyle() {
      return `background:${this.colorMap.optBac};color:${this.colorMap.optCol};`;
    },
    optActiveStyle() {
      return `background:${this.colorMap.optBacActive};color:${this.colorMap.optColActive};`;
    },
  },
  mounted() {
    this.openTipCard = this.openTipCards;
    if (Array.isArray(this.questionList)) {
      this.newOptList = this.deepClone(this.questionList);
      this.newOptList.map((e) => {
        e.openTipCard = this.openTipCard;
      });
      this.answerList = [...Array(this.newOptList.length)].map((e) => "答案");
      this.chooseList = [...Array(this.newOptList.length)].map((e) => "");
      this.showTrueAnswer();
      if (this.newOptList.length === 1) this.isEnd = true;
    }
    this.startTime();
    this.colorMap = this.deepMerge(this.colorMap, this.colorStyle);
  },
  methods: {
    startTime() {
      this.timeStart = new Date().getTime();
      console.log("初始时间===", new Date().getTime());
    },
    // 事件触发，每秒一次
    suspend(timestamp) {
      console.log("www", timestamp);
    },
    // ref形式获取内部的值
    getSeconds() {
      var sheng = this.$refs.uCountDown.suspend(true).split(":");
      this.allTime = this.timestamp - Number(sheng[0]) * 3600 - Number(sheng[1]) * 60 - Number(sheng[2]);
    },
    // 倒计时结束触发
    countDownEnd() {
      let tip = "考试时间已截止";
      this.$message({
        message: tip,
        type: "error",
      });
      let time1 = setTimeout(() => {
        let opt = {
          current_id: this.showQuestionIndex,
          isEnd: this.isEnd,
        };
        this.lastOpt = opt;
        let chooseStr = this.showChooseAnswer(opt);
        this.chooseList.splice(this.showQuestionIndex, 1, chooseStr);
        // // console.log('选择答案列表',this.chooseList);
        this.tika();
        this.formatKey(this.lastOpt);
        this.$parent.autoPush = true;
      }, 2000);
      time1 = "";
    },
    // 深度克隆 对象
    deepClone(obj) {
      // 对常见的“非”值，直接返回原来值
      if ([null, undefined, NaN, false].includes(obj)) return obj;
      if (typeof obj !== "object" && typeof obj !== "function") {
        //原始类型直接返回
        return obj;
      }
      var o = Array.isArray(obj) ? [] : {};
      for (let i in obj) {
        if (obj.hasOwnProperty(i)) {
          o[i] = typeof obj[i] === "object" ? this.deepClone(obj[i]) : obj[i];
        }
      }
      return o;
    },
    // 深度合并 对象
    deepMerge(target = {}, source = {}) {
      target = this.deepClone(target);
      if (typeof target !== "object" || typeof source !== "object") return false;
      for (const prop in source) {
        if (!source.hasOwnProperty(prop)) continue;
        if (prop in target) {
          if (typeof target[prop] !== "object") {
            target[prop] = source[prop];
          } else {
            if (typeof source[prop] !== "object") {
              target[prop] = source[prop];
            } else {
              if (target[prop].concat && source[prop].concat) {
                target[prop] = target[prop].concat(source[prop]);
              } else {
                target[prop] = this.deepMerge(target[prop], source[prop]);
              }
            }
          }
        } else {
          target[prop] = source[prop];
        }
      }
      return target;
    },
    // 获取题目类型
    getQuestionType(code) {
      let name = "问题";
      switch (code) {
        case "write":
          name = "填空题";
          break;
        case "radio":
          name = "单选题";
          break;
        case "checkbox":
          name = "多选题";
          break;
        case "determine":
          name = "判断题";
          break;
      }
      return name;
    },
    // 显示正确答案
    showTrueAnswer() {
      // 接口答案【id1，id2】以数组形式存在（单/双选）
      this.trueA = "";
      let choose = this.deepClone(this.newOptList[this.showQuestionIndex].answer);
      let answers = this.deepClone(this.newOptList[this.showQuestionIndex].question_option);
      answers.map((item) => {
        choose.map((e) => {
          if (e == item.id) {
            if (this.trueA == "") {
              this.trueA = item.topic;
            } else {
              this.trueA += item.topic;
            }
          }
        });
      });

      this.answerList.splice(this.showQuestionIndex, 1, this.trueA);
      // console.log("正确答案列表", this.answerList);
     
      return this.trueA;
    },
    // 选择答案
    checkOption(e) {
      this.chooseAnswer = e.currentTarget.dataset.id;
      //选择事件
      let checkOpt = this.newOptList[this.showQuestionIndex];
      this.checkActive(e.currentTarget.dataset.id);
      //返回数据
      let opt = {
        id: this.newOptList[this.showQuestionIndex].id,
        value: e.currentTarget.dataset.id,
      };
    },

    checkActive(_id) {
      //选择答案事件处理
      let newOpt = this.newOptList;
      let checkOpt = newOpt[this.showQuestionIndex].question_option;
      if (newOpt[this.showQuestionIndex].type == "radio") {
        checkOpt.map((item, i) => {
          if (item.id == _id) {
            item.active = !item.active;
          } else {
            item.active = false;
          }
        });
      } else if (newOpt[this.showQuestionIndex].type == "checkbox") {
        checkOpt.map((item, i) => {
          if (item.id == _id) {
            item.active = !item.active;
          }
        });
      } else {
        checkOpt.map((item, i) => {
          if (item.id == _id) {
            item.active = !item.active;
          } else {
            item.active = false;
          }
        });
      }
      this.newOptList = newOpt;
    },
    changeTipStatus() {
      let newOpt = this.newOptList;
      // this.$set(newOpt[this.showQuestionIndex],newOpt[this.showQuestionIndex].openTipCard,!newOpt[this.showQuestionIndex].openTipCard)
      newOpt[this.showQuestionIndex].openTipCard = !newOpt[this.showQuestionIndex].openTipCard;
      this.$nextTick(() => {
        this.newOptList = newOpt;
      });
    },
    startItem(e) {
      this.newOptList[this.showQuestionIndex].is_collect = !this.newOptList[this.showQuestionIndex].is_collect;

      let opt = {
        id: e,
        is_collect: this.newOptList[this.showQuestionIndex].is_collect,
      };
      this.$emit("starOption", opt);
    },
    openCard() {
      this.showAnswerNumber = true;
      let opt = {
        current_id: this.showQuestionIndex,
      };
      let chooseStr = this.showChooseAnswer(opt);
      // // console.log("当前点击index",this.showQuestionIndex);
      this.chooseList.splice(this.showQuestionIndex, 1, chooseStr);
      this.tika();
    },
    // 答题卡
    tika() {
      if (this.openTipCards) {
        var choose = this.deepClone(this.chooseList);
        var answer = this.deepClone(this.answerList);
        if (choose[this.showQuestionIndex] == answer[this.showQuestionIndex]) {
          this.tikaList[this.showQuestionIndex] = "yes";
        } else {
          if (choose[this.showQuestionIndex]) {
            this.tikaList[this.showQuestionIndex] = "no";
          } else {
            this.tikaList[this.showQuestionIndex] = "kong";
          }
        }
      } else {
        this.tikaList = [];
        var choose = this.deepClone(this.chooseList);
        var answer = this.deepClone(this.answerList);
        choose.forEach((e, index) => {
          answer.forEach((er, index1) => {
            if (index == index1) {
              if (e == er) {
                this.tikaList.push("yes");
              } else {
                if (e == "") {
                  this.tikaList.push("kong");
                } else {
                  this.tikaList.push("no");
                }
              }
            }
          });
        });
      }

      console.log("答题卡", this.tikaList);

      var lastAnswer = this.tikaList.reduce(function (items, item) {
        if (item in items) {
          items[item]++;
        } else {
          items[item] = 1;
        }
        return items;
      }, {});
      this.statistics = lastAnswer;
    },
    //上一题
    proQuestionBtn(e) {
      if (this.isStart) {
        this.switchQuestion(this.pro);
        let opt = {
          current_id: this.showQuestionIndex,
          isEnd: this.isEnd,
        };
        let chooseStr = this.showChooseAnswer(opt);
        this.chooseList.splice(this.showQuestionIndex, 1, chooseStr);
        this.tika();
      }
    },
    showChooseAnswer(opt) {
      // 答案汇总
      let newOpt = this.deepClone(opt);
      let newAnswer = [];
      let newList = this.newOptList;
      let formatCheck_res = [];
      newList.forEach((item, i) => {
        let key_res = [];
        let test_item = {
          id: item.id,
          keyFormat: [],
        };
        let test = [];
        if (item.type == "write") {
          key_res.push(item.question_key.trim());
          test_item.keyFormat.push(item.question_key.trim());
        } else {
          item.question_option.forEach((item_s, i_s) => {
            if (item_s.active) {
              key_res.push(item_s);
              test_item.keyFormat.push(item_s.id);
            }
          });
        }
        formatCheck_res.push(test_item);
        newAnswer.push({
          id: item.id,
          type: item.type,
          number: item.number,
          title: item.title,
          keyRes: key_res,
        });
      });
      newOpt.checkRes = {
        check_res: newAnswer,
        keyFormat: formatCheck_res,
      };
      let proChoose = "";
      newAnswer[this.showQuestionIndex].keyRes.forEach((ress) => {
        if (proChoose == "") {
          proChoose = ress.topic;
        } else {
          proChoose += ress.topic;
        }
      });
      return proChoose;
    },
    //下一题
    nextQuestionBtn(e) {
      //构建返回数据
      let opt = {
        current_id: this.showQuestionIndex,
        isEnd: this.isEnd,
      };
      if (!this.isEnd) {
        this.switchQuestion(this.next);
      } else {
        this.confirmSubmission = true;
        this.lastOpt = opt;
      }
      let chooseStr = this.showChooseAnswer(opt);
      this.chooseList.splice(this.showQuestionIndex, 1, chooseStr);
      this.tika();
      this.isStart = true;
    },
    // 提示确认
    confirmSub() {
      this.formatKey(this.lastOpt);
    },
    // 跳转题目
    toThis(index) {
      this.switchVisible = true;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        let newList = this.newOptList;
        this.showQuestionIndex = index;
        if (newList.length == 1) {
          this.isStart = false;
          this.isEnd = true;
        } else if (this.showQuestionIndex == newList.length - 1) {
          this.isStart = true;
          this.isEnd = true;
        } else if (this.showQuestionIndex == 0) {
          this.isStart = false;
          this.isEnd = false;
        } else {
          this.isEnd = false;
          this.isStart = true;
        }
        this.switchVisible = false;
        this.showAnswerNumber = false;
        this.showTrueAnswer();
        
      }, 100);
    },
    // 切换题目
    switchQuestion(e) {
      this.switchVisible = true;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        let newList = this.newOptList;
        if (e == true && this.showQuestionIndex < newList.length - 1) {
          this.showQuestionIndex = this.showQuestionIndex + 1;
          if (this.showQuestionIndex == newList.length - 1) {
            this.isEnd = true;
          }
          this.switchVisible = false;
        } else {
          this.showQuestionIndex = this.showQuestionIndex - 1;
          if (this.showQuestionIndex == 0) {
            this.isStart = false;
          }
          this.isEnd = false;
          this.switchVisible = false;
        }
        this.showTrueAnswer();
      }, 100);
    },
    checked() {
      wx.showToast({
        title: "请看完视频作答",
        icon: "none",
      });
    },
    //答案选择验证
    checkTest() {
      let check_res = false;
      if (this.newOptList[this.showQuestionIndex].type == "write") {
        if (this.newOptList[this.showQuestionIndex].question_key.trim()) check_res = true;
      } else {
        let check_opt = this.newOptList[this.showQuestionIndex];
        check_opt.question_option.forEach((item, i) => {
          if (item.active) {
            check_res = true;
            return;
          }
        });
      }
      return check_res;
    },
    //答案整理返回
    formatKey(opt) {
      let newAnswer = [];
      let newList = this.newOptList;
      let formatCheck_res = [];
      let result = [];
      newList.forEach((item, i) => {
        let key_res = [];
        let test_item = {
          id: item.id,
          keyFormat: [],
          // ids:[],
          pass: this.tikaList[i] == "yes" ? 1 : this.tikaList[i] == "no" ? 0 : 2,
        };
        let test = [];
        if (item.type == "write") {
          key_res.push(item.question_key.trim());
          test_item.keyFormat.push(item.question_key.trim());
        } else {
          item.question_option.forEach((item_s, i_s) => {
            if (item_s.active) {
              key_res.push(item_s);
              test_item.keyFormat.push(item_s.id);
            }
          });
        }

        formatCheck_res.push(test_item);

        newAnswer.push({
          id: item.id,
          type: item.type,
          number: item.number,
          title: item.title,
          keyRes: key_res,
        });
      });
      // this.getSeconds();
      // 正计时，不用显示
      this.allTime = (new Date().getTime() - this.timeStart) / 1000;
      console.log("jieshu时间===", this.allTime);
      opt.checkRes = {
        // check_res: newAnswer,
        keyFormat: formatCheck_res,
        correct_quantity: this.statistics.yes ? this.statistics.yes : 0,
        errors_quantity: this.statistics.no ? this.statistics.no : 0,
        tika: this.tikaList,
        times: this.allTime,
        newList: this.newOptList,
      };
      this.$emit("confrimAll", opt);
      this.$nextTick(function () {
        this.showQuestionIndex = 0; //当前展示题号
        this.isEnd = false; //是否为最后一题
        this.isStart = false; //是否第一题
        this.switchVisible = false; // 切换状态
        this.pro = false; //上一题
        this.next = true; //下一题
        (this.chooseAnswer = ""), //选择答案
          (this.trueA = ""), //正确答案
          (this.answerList = []), //答案列表
          (this.chooseList = []), //选择列表
          (this.tikaList = []);
      });

      // this.$emit('confrimAll', opt)
    },
  },
};
</script>

<style lang="scss" scoped>
view {
  box-sizing: border-box;
}

.answer__content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
}

.answer__banner {
  width: 100%;
  height: 221px;
}

.answer__banner swiper,
.answer__banner swiper swiper-item {
  width: 100%;
  height: 100%;
}

.answer__banner swiper swiper-item img {
  width: 100%;
  height: 100%;
}

.answer__question {
  width: 100%;
  padding: 0 0px 11px;
  // margin-top: 17px;
}

.title-tips {
  width: 62px;
  height: 30px;
  background: rgb(254, 71, 68);
  border-radius: 6px;
  color: white;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  margin-bottom: 15px;
}

.answer__question .question_title {
  display: flex;
  width: 100%;
  font-size: 16px;
  line-height: 23px;
  color: rgb(10, 33, 51);
}

.answer__question .title__number {
  padding-top: 0px;
  min-width: 19px;
}

.answer__question .question__option {
  width: 100%;
  margin-top: 7px;
}

.answer__question .question__option__item {
  position: relative;
  display: flex;
  width: 100%;
  padding: 13px 18px;
  box-sizing: border-box;
  margin-top: 17px;
  font-size: 16px;
  color: #232131;
  background: #eeb67a;
  border-radius: 8px;
  overflow: hidden;
}
.falseBc {
  background-color: #fff9ee !important;
  color: #ffaf0f !important;
}
.rightIcon {
  width: 19px;
  height: 16px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 2%;
  background-image: url("~@/assets/icon/red_right.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.falseIcon {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 2%;
  background-image: url("~@/assets/icon/yello_faults.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.answer__question .question__option__item .question__option__item__number {
  // padding-top: 2px;
  margin-right: 6px;
  white-space: nowrap;
}

.answer__next__btn {
  //   position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 14px 11px;
  width: 100%;
  height: 80px;
  line-height: 51px;
  color: #ffffff;
  font-size: 17px;
  text-align: center;
  background: #ffffff;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.tips {
  position: absolute;
  width: 29px;
  height: 29px;
  top: 50%;
  transform: translateY(-50%);
  right: 17px;

  image {
    width: 100%;
    height: 100%;
  }
}

.bottom-left {
  width: 136px;
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  color: rgb(10, 33, 51);
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;

  .star {
    display: flex;
    justify-content: start;
    align-items: center;
    align-content: center;

    image {
      width: 21px;
      height: 21px;
      margin-right: 2px;
    }
  }

  .right {
    color: rgb(255, 175, 15);
    display: flex;
    margin-right: 2px;
    .img {
      width: 21px;
      height: 21px;
      margin-right: 2px;
      border-radius: 50%;
      background-color: rgb(255, 175, 15);
      display: flex;
      align-items: center;
      justify-content: center;
      image {
        width: 9px;
        height: 8px;
      }
    }
  }

  .fault {
    color: rgb(254, 71, 68);
    display: flex;
    .img {
      width: 21px;
      height: 21px;
      margin-right: 2px;
      border-radius: 50%;
      background-color: rgb(254, 71, 68);
      display: flex;
      align-items: center;
      justify-content: center;
      image {
        width: 9px;
        height: 9px;
      }
    }
  }
}

// .btns {
//   width: 258px;
//   height: 55px;
//   display: flex;
//   flex-direction: row;
//   justify-content: space-around;
//   align-items: center;
//   align-content: center;
// }
.btns {
  width: 382px;
  height: 55px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  align-content: center;
}
.answer_pro {
  position: relative;
  width: 129px;
  height: 55px;
  background-color: #fbe5e3 !important;
  color: rgb(254, 71, 68) !important;
  // border-radius: 9px 0 0 9px;
  border-radius: 9px;
  cursor: pointer;
}

.pro-right {
  background-color: rgb(254, 71, 68) !important;
  color: white !important;
  // border-radius: 0 9px 9px 0 !important;
}

.question__option__active {
  color: #ffffff !important;
  background-color: #c9784f !important;
}

.item__key__box {
  display: flex;
  width: 100%;
  margin-top: 17px;

  .write_input {
    width: 228px;
    font-size: 16px;
    color: #333333;
    text-align: center;
    border-bottom: 1px solid #999999;
  }
}

.question--find-out {
  transform: scale(0) translateX(-100%);
  transition: all 0.3s;
}

.question--find-in {
  animation: findIn-question 0.3s;
}

.coverTest {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 998;
  height: 100%;
  width: 100%;
  background-color: #000000;
  opacity: 0.3;
  border-radius: 9px;
}

@keyframes findIn-question {
  from {
    transform: scale(0);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

// .exam-number {
// 	position: absolute;
// 	top: 17px;
// 	right: 0;
// 	min-width: 68px;
// 	color: rgb(108, 122, 133);
// 	font-size: 18px;
// 	font-weight: 400;
// 	line-height: 25px;

// 	image {
// 		width: 14px;
// 		height: 14px;
// 		margin-right: 6px;
// 	}
// }

.choice-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;

  .list-item {
    cursor: pointer;
    width: 33px;
    height: 33px;
    margin: 9px;
    border-radius: 50%;
    font-size: 14px;
    line-height: 33px;
    text-align: center;
    color: rgb(181, 188, 193);
    background-color: rgb(243, 244, 245);
    border: 1px solid rgb(181, 188, 193);
    &:nth-of-type(8n + 8) {
      margin-right: 0;
    }
  }

  .item-r {
    background-color: rgb(236, 253, 255) !important;
    border: 1px solid rgb(12, 230, 255) !important;
  }

  .item-f {
    background-color: rgb(255, 228, 227) !important;
    border: 1px solid rgb(254, 71, 68) !important;
  }
}

.content {
  padding: 34px 11px;
}

.analysis-top {
  width: 97%;
  height: 66px;
  background: rgb(243, 244, 245);
  border-radius: 11px;
  padding: 17px 11px;
  display: flex;
  justify-content: start;
  align-items: center;
  align-content: center;
  text-align: left;
  color: rgb(10, 33, 51);
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  margin-bottom: 25px;

  .left {
    width: 50%;
  }

  .right {
    width: 50%;
  }
}

.analysis-title {
  position: relative;
  width: 100%;
  height: 25px;
  color: rgb(10, 33, 51);
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  align-content: center;
  text-align: center;
  margin-bottom: 25px;

  .line {
    width: 11px;
    height: 2px;
    background-color: rgb(181, 188, 193);
    display: inline-block;
    margin: 0 7px;
  }
}

.analysis-content {
  width: 100%;
  color: rgb(10, 33, 51);
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;

  .title {
    margin-bottom: 17px;
  }

  .content-a {
    color: rgb(108, 122, 133);
  }
}
.count-time {
  height: 25px;
  color: rgb(10, 33, 51);
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 23px;
  .exam-number {
    min-width: 68px;
    color: rgb(108, 122, 133);
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    image {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }
  }
}
.open_card {
  width: 100%;
  min-height: 237px;
  box-sizing: border-box;
  transition: all 0.5s;
  -webkit-transition: all 0.5s; /* Safari */
}
.close_card {
  width: 100%;
  //   height: 62px;
  box-sizing: border-box;
  transition: all 0.5s;
  -webkit-transition: all 0.5s; /* Safari */
}
.transitionIcon {
  position: absolute;
  right: 2%;
  top: 20%;
  transform: rotate(0deg);
  transition: all 0.5s;
  -webkit-transition: all 0.5s; /* Safari */
}
.transitionIcon-down {
  position: absolute;
  right: 2%;
  top: 20%;
  transform: rotate(180deg);
  transition: all 0.5s;
  -webkit-transition: all 0.5s; /* Safari */
}

.card {
  //   width: 60%;
  padding: 26px 20px 23px;
  margin: 0 0 20px;
  background: #ffffff;
  .card_body {
    .card_tab {
      position: relative;
      width: 100%;
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(49, 44, 44, 1);
      line-height: 22px;
      margin-bottom: 27px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      i {
        width: 4px;
        height: 16px;
        display: inline-div;
        background-color: rgba(231, 68, 47, 1);
        margin-right: 8px;
      }
    }
    .person-con {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 80%;
      height: 60px;

      .icon-bg {
        .icon {
          width: 60px;
          height: 60px;
          display: inline-div;
          border-radius: 50%;
          box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
          border: 1px solid white;
          margin-right: -12px;
        }
      }
    }

    .btn_arrow {
      width: 80px;
      height: 32px;
      background-color: #f2f3f3;
      border-radius: 100px;
      color: #808080;
      font-size: 10px;
      text-align: center;
      line-height: 32px;
    }
    .btn {
      width: 95%;
      height: 52px;
      background-color: rgba(250, 250, 250, 1);
      color: rgba(49, 44, 44, 1);
      font-size: 14px;
      line-height: 52px;
      text-align: left;
      padding-left: 18px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
    .btns {
      display: flex;
      justify-content: space-between;

      .defaultBtn {
        width: 165px;
        height: 52px;
        background-color: rgba(250, 250, 250, 1);
        color: rgba(49, 44, 44, 1);
        font-size: 14px;
        line-height: 52px;
        text-align: center;
      }
    }
    .pic_bg {
      width: 100%;
      height: 150px;
      margin-bottom: 20px;
    }
    .line {
      width: 100%;
      border: 1px solid rgba(242, 241, 241, 1);
      margin-bottom: 20px;
    }
    .product-name {
      height: 20px;
      font-size: 14px;
      text-align: left;
      line-height: 20px;
      margin-bottom: 20px;
      font-weight: 600;
    }
    .product-icon {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 20px;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .icon {
          width: 26px;
          height: 26px;
          display: div;
          margin-bottom: 9px;
        }
      }
    }

    .img-zxc {
      width: 100%;
      height: auto;
      position: relative;
      margin-bottom: 5px;
      font-size: 14px;
      line-height: 20px;

      img {
        max-width: 100% !important;
        height: auto;
      }
      p {
        width: 100%;

        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
